import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {normalizeStyles, typographyStyles} from '@webs/components-library/theming';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement('webs-footer-menu-item')
export class FooterMenuItem extends LitElement {
  static styles = [
    normalizeStyles,
    typographyStyles,
    css`
      :host {
        display: block;
      }

      a, p {
        color: var(--color-light-grey);
        font-family: var(--font-family-alternative);
        font-weight: var(--font-weight-semibold);
        font-size: 0.7rem !important;
        margin: 0;
        text-decoration: none;
        transition: color .1s linear;
      }

      a:hover {
        color: var(--color-primary);
      }

      a.subfooter, p.subfooter {
        font-family: var(--font-family-heading);
        font-weight: var(--font-weight-base);
        margin: 0 .75rem;
      }
    `,
  ];
  @property()
  href: string;

  @property({attribute: 'settings-id'})
  sectionId: string;

  @property({attribute: 'settings-class'})
  sectionClass: string;

  @property()
  text: string;

  @property()
  type: string | undefined = undefined;

  protected render(): unknown {
    let classes: string[] = [this.sectionClass, this.type];
    classes = classes.filter(value => value);
    return (this.sectionId && this.sectionClass) || this.href ? html`
      <a id="${ifDefined(this.sectionId)}" class="${ifDefined(classes.join(' '))}"
         href="${this.href || "javascript:;"}">${this.text}</a>
    ` : html`
      <p class="${ifDefined(this.type)}">${this.text}</p>
    `;
  }
}
